import React from 'react';

export const ArrowRight = ({ color }) => {
  return (
    <svg width="27px" height="16px" viewBox="0 0 27 16">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g className="arrow-color" transform="translate(-1727.000000, -544.000000)" stroke={color} strokeWidth="2">
          <g transform="translate(1622.000000, 527.000000)">
            <g transform="translate(20.000000, 15.000000)">
              <g transform="translate(97.500000, 10.000000) scale(-1, 1) rotate(-180.000000) translate(-97.500000, -10.000000) translate(85.000000, 3.000000)">
                <polyline id="Path-2" points="18 0 25 7 18 14"></polyline>
                <line x1="25" y1="7" x2="0" y2="7" id="Path-3"></line>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ArrowLeft = ({ color }) => {
  return (
    <svg width="27px" height="16px" viewBox="0 0 27 16">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g className="arrow-color" transform="translate(-1057.000000, -769.000000)" stroke={color} strokeWidth="2">
          <g transform="translate(1036.000000, 753.000000)">
            <g transform="translate(35.500000, 24.000000) rotate(-180.000000) translate(-35.500000, -24.000000) translate(23.000000, 17.000000)">
              <polyline id="Path-2" points="18 0 25 7 18 14"></polyline>
              <line x1="25" y1="7" x2="0" y2="7" id="Path-3"></line>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};




export const ArrowDown = ({color}) => (
  <svg viewBox="0 0 44 38" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.04 1.528c17.462-.285 31.848 13.466 32.133 30.718l6.55-6.7a1.414 1.414 0 0 1 1.932.017c.536.514.57 1.353.077 1.908l-8.897 9.102a1.41 1.41 0 0 1-1.983.034l-9.209-8.786a1.374 1.374 0 0 1-.034-1.959 1.415 1.415 0 0 1 1.983-.034l6.779 6.467C31.11 16.572 18.003 4.039 2.088 4.297a1.393 1.393 0 0 1-1.426-1.36A1.393 1.393 0 0 1 2.04 1.528Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
)


export const ExitIcon = ({color}) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill={color} fillRule="nonzero" className='exit-icon'>
      <path d="M23.924 10.618a1.011 1.011 0 0 0-.217-.326l-3-3a1 1 0 0 0-1.413 1.415L20.587 10H15a1 1 0 1 0 0 2h5.587l-1.293 1.293a.999.999 0 1 0 1.414 1.414l3-3a1.001 1.001 0 0 0 .217-1.09Z" />
      <path d="M17 14a1 1 0 0 0-1 1v5h-4V4c0-.441-.29-.831-.713-.958L7.814 2H16v5a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1H1C.964 0 .932.015.897.019a1.002 1.002 0 0 0-.424.148C.451.181.424.182.403.198.395.204.392.215.384.221a.99.99 0 0 0-.266.316C.104.564.101.593.09.621.058.697.023.771.011.855c-.005.03.004.058.003.087C.013.962 0 .98 0 1v20a1 1 0 0 0 .804.98l10 2A.999.999 0 0 0 12 23v-1h5a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1Z" />
    </g>
  </svg>
)


export const RestartIcon = ({color}) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox='0 0 53 62'
  >
    <path
      d="M49.639 23.884C44.382 12.995 32.616 7.487 21.35 9.49l3.003-5.633c.751-1.251.25-2.879-1-3.504-1.252-.751-2.88-.25-3.505 1l-6.134 11.391s-1.377 2.253.75 3.254l11.39 6.134c.377.25.877.375 1.252.375.877 0 1.878-.5 2.253-1.376.751-1.252.25-2.88-1-3.505l-5.884-3.255c8.887-1.502 18.15 3.004 22.28 11.515 5.006 10.389.625 22.905-9.764 27.787-5.007 2.378-10.639 2.754-15.896.876-5.257-1.877-9.512-5.632-11.89-10.638-2.378-5.007-2.754-10.639-.877-15.896.5-1.377-.25-2.88-1.627-3.38-1.251-.25-2.753.501-3.254 1.878C-.804 33.147-.43 40.156 2.575 46.414 5.58 52.672 10.836 57.43 17.47 59.807c2.88 1.001 5.758 1.503 8.637 1.503 3.88 0 7.76-.877 11.264-2.628 13.018-6.26 18.525-21.905 12.267-34.796l.002-.002Z"
      fill={color}
      className="restart-arrow"
    />
  </svg>
)


